module.exports = __webpack_public_path__ + "files/920d36df288df3e47aa641cf89500f3e.jpg";